import { useEffect, useState } from "react";
import AuthProvider from "./AuthContext";
import CartProvider from "./CartContext";
import WarehouseProvider from "./WarehouseContext";
import ContentProvider from "./ContentContext";
import CartEffects from "../effects/CartEffects";
import { loadCompanyConfig, isCompanyLoaded } from "../../config/companyConfig";

const CompanyGate = ({ children }) => {
  const [ready, setReady] = useState(isCompanyLoaded);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (ready) return;
    let active = true;
    loadCompanyConfig()
      .then(() => {
        if (active) setReady(true);
      })
      .catch((err) => {
        if (active) {
          console.error("Error cargando configuración de compañía:", err);
          setError(err);
        }
      });
    return () => {
      active = false;
    };
  }, [ready]);

  if (error) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "0.75rem",
          fontFamily: "system-ui, sans-serif",
          color: "#333",
        }}
      >
        <i className="pi pi-exclamation-triangle" style={{ fontSize: "2rem", color: "#d97706" }} />
        <p style={{ margin: 0, fontWeight: 600 }}>No se pudo cargar la configuración del portal.</p>
        <p style={{ margin: 0, fontSize: "0.85rem", color: "#666" }}>Verifica tu conexión e inténtalo nuevamente.</p>
      </div>
    );
  }

  if (!ready) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <i className="pi pi-spin pi-spinner" style={{ fontSize: "1.5rem" }} />
      </div>
    );
  }

  return children;
};

const AppProviders = ({ children }) => {
  return (
    <CompanyGate>
      <ContentProvider>
        <WarehouseProvider>
          <CartProvider>
            <AuthProvider>
              <CartEffects />
              {children}
            </AuthProvider>
          </CartProvider>
        </WarehouseProvider>
      </ContentProvider>
    </CompanyGate>
  );
};

export default AppProviders;